export const isNonEmptyArray = <T>(array: T[]): array is [T, ...T[]] => array.length > 0
